(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-share"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.blog-post-share__copy').forEach((button) => {
    button.addEventListener('click', async () => {
      const url = button.dataset.shareUrl;
      if (!url) return;

      try {
        await navigator.clipboard.writeText(url);
      } catch (error) {
        window.prompt('Copy link', url);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
